"use strict";

var _regeneratorRuntime = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConsoleReporter = void 0;

var isomorphic_logger_1 = __importDefault(require("@spotify-internal/isomorphic-logger"));

var ConsoleReporter =
/*#__PURE__*/
function () {
  function ConsoleReporter() {
    var spacingLevel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
    var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';

    _classCallCheck(this, ConsoleReporter);

    this.spacingLevel = spacingLevel;
    this.logLevel = logLevel;
  }

  _createClass(ConsoleReporter, [{
    key: "send",
    value: function send(metrics) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isomorphic_logger_1.default.log(this.logLevel, "[semantic-metrics] ".concat(JSON.stringify(metrics, null, this.spacingLevel)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return ConsoleReporter;
}();

exports.ConsoleReporter = ConsoleReporter;